import React from "react";
import PropTypes from "prop-types";
import {
  Toolbar,
  Typography,
  AppBar,
  Button,
  withStyles,
  IconButton
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

const styles = {
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  }
};

const Header = props => {
  const { classes } = props;
  const pagesWithoutWorkarea = [
    "/portal2/download",
    "/portal2/status",
    "portal2/ctd/download"
  ];
  const pagesWithoutOrganization = [
    "/portal2/download",
    "/portal2/status",
    "portal2/ctd/download"
  ];
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => props.onToggleAppDrawer()}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" className={classes.flex}>
            Hakai Data Portal
            {props.mode !== "production" && ` - ${props.mode}`}
          </Typography>
          <div>
            {props.organization &&
              !pagesWithoutOrganization.includes(props.location.pathname) && (
                <Button
                  variant="text"
                  onClick={props.onChangeOrganization}
                  color="default"
                  align="right"
                  style={{ color: "#FFAD05" }}
                >
                  {`Org: ${props.organization.replace("-", " ")}`}
                </Button>
              )}
          </div>
          <div>
            {props.workarea &&
              !pagesWithoutWorkarea.includes(props.location.pathname) && (
                <Button
                  variant="text"
                  onClick={props.onChangeWorkarea}
                  color="default"
                  align="right"
                  style={{ color: "#FFAD05" }}
                >
                  {`Work Area: ${props.workarea.replace("-", " ")}`}
                </Button>
              )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

Header.propTypes = {
  classes: PropTypes.shape({ flex: PropTypes.string, root: PropTypes.string })
    .isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  mode: PropTypes.string.isRequired,
  onChangeWorkarea: PropTypes.func.isRequired,
  onChangeOrganization: PropTypes.func.isRequired,
  workarea: PropTypes.string,
  organization: PropTypes.string,
  onToggleAppDrawer: PropTypes.func.isRequired
};

Header.defaultProps = {
  workarea: undefined,
  organization: undefined
};

export default withStyles(styles)(Header);
